import {getMethod, postMethod} from '~/api'

async function get(request) {
    return await getMethod('/proxy/tripAssistant', request)
}

async function post(request) {
    return await postMethod('/proxy/tripAssistant', request)
}

export {get, post}
